export default __webpack_public_path__ + "static/media/send.0db42b73.mp3";